/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFilePreviewGroupedResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfFilePreviewGroupedResponseFromDiscriminatorValue, serializeFilePreviewGroupedResponse, type FilePreviewGroupedResponse, type HttpValidationProblemDetails, type IError, type PaginatedResultOfFilePreviewGroupedResponse } from '../../../models/index.js';
// @ts-ignore
import { type AdditionalDataHolder, type BaseRequestBuilder, type Parsable, type ParsableFactory, type ParseNode, type RequestConfiguration, type RequestInformation, type RequestsMetadata, type SerializationWriter } from '@microsoft/kiota-abstractions';

/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PreviewsPostRequestBody}
 */
// @ts-ignore
export function createPreviewsPostRequestBodyFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPreviewsPostRequestBody;
}
/**
 * The deserialization information for the current model
 * @param PreviewsPostRequestBody The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPreviewsPostRequestBody(previewsPostRequestBody: Partial<PreviewsPostRequestBody> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "large": n => { previewsPostRequestBody.large = n.getByteArrayValue(); },
        "medium": n => { previewsPostRequestBody.medium = n.getByteArrayValue(); },
        "small": n => { previewsPostRequestBody.small = n.getByteArrayValue(); },
    }
}
export interface PreviewsPostRequestBody extends AdditionalDataHolder, Parsable {
    /**
     * The large property
     */
    large?: ArrayBuffer | null;
    /**
     * The medium property
     */
    medium?: ArrayBuffer | null;
    /**
     * The small property
     */
    small?: ArrayBuffer | null;
}
/**
 * Builds and executes requests for operations under /files/{file-id}/previews
 */
export interface PreviewsRequestBuilder extends BaseRequestBuilder<PreviewsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfFilePreviewGroupedResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<PreviewsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfFilePreviewGroupedResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FilePreviewGroupedResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: PreviewsPostRequestBody, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FilePreviewGroupedResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<PreviewsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: PreviewsPostRequestBody, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface PreviewsRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PreviewsPostRequestBody The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePreviewsPostRequestBody(writer: SerializationWriter, previewsPostRequestBody: Partial<PreviewsPostRequestBody> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!previewsPostRequestBody || isSerializingDerivedType) { return; }
    writer.writeByteArrayValue("large", previewsPostRequestBody.large);
    writer.writeByteArrayValue("medium", previewsPostRequestBody.medium);
    writer.writeByteArrayValue("small", previewsPostRequestBody.small);
    writer.writeAdditionalData(previewsPostRequestBody.additionalData);
}
/**
 * Uri template for the request builder.
 */
export const PreviewsRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/previews{?page*,pageSize*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const PreviewsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PreviewsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfFilePreviewGroupedResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: PreviewsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFilePreviewGroupedResponseFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializePreviewsPostRequestBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
